import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthService {
    set encryptedAccessToken(token: string) {
        localStorage.setItem('enc_auth_token', token);
    }

    get encryptedAccessToken(): string {
        return localStorage.getItem('enc_auth_token') ?? '';
    }

    constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private _msalService: MsalService, private _router: Router) {
    }

    signOut(): Observable<void> {
        return this._msalService.logoutPopup({ mainWindowRedirectUri: '/login' });
    }

    checkUserLogin(): boolean {
        return this._msalService.instance.getAllAccounts().length > 0;
    }

    loginWithMicrosoft() {
        if (this.msalGuardConfig.authRequest) {
            this._msalService.loginRedirect({ scopes: ['openid', 'profile', environment.msalInterceptorConfigUrl] })
        } else {
            this._msalService.loginRedirect()
        }
    }

    checkAndSetActiveAccount() {
        let activeAccount = this._msalService.instance.getActiveAccount();

        if (!activeAccount && this._msalService.instance.getAllAccounts().length > 0) {
            let accounts = this._msalService.instance.getAllAccounts();
            this._msalService.instance.setActiveAccount(accounts[0]);
        }
    }
}
